export default __webpack_public_path__ + "static/sample-photo-3dbafe918be50ca51436eed1370bd005.png";